import React, { HTMLProps, RefObject, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Chevron from './Chevron'
import { ChevronType, Direction } from '../utils/constants'
import { twMerge } from 'tailwind-merge'

interface ScrollLinkAltProps extends HTMLProps<HTMLButtonElement> {
  title: string
  scrollRef: RefObject<HTMLDivElement>
}

const ScrollLinkAlt = ({ title, scrollRef, className }: ScrollLinkAltProps) => {
    const [isHovered, setIsHovered] = useState(false)

    const onClick = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
        }
    }
    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={twMerge('border rounded-full group relative', className)}
        >
            <div className='transition-all duration-500 ease-out rounded-full px-8 py-5 flex items-center group-hover:bg-black group-hover:text-white'>
                <FormattedMessage id={title} tagName='h6' />
                <div className='flex flex-col fill-black group-hover:fill-white transition-all duration-500 ease-out'>
                    <Chevron direction={Direction.DOWN} type={ChevronType.FULL} />
                </div>
            </div>
        </button>
    )
}

export default ScrollLinkAlt
